import { ReactNode } from "react";
import cls from "../../utils/cls";
import { ErrorMessage } from "../forms";

interface CheckProps {
  checked?: boolean;
  onValueChange: (value: boolean) => void;
  name: string;
  id?: string;
  label?: string;
  rightLabel?: string;
  className?: string;
  children?: ReactNode;
  error?: string | boolean | null;
  inline?: boolean;
}

const CheckInputBlock = ({ name, id, onValueChange, checked, className, error, children, inline = false, ...props }: CheckProps) => {
  return (
    <div className={className}>
      <label
        className={cls("flex ", "cursor-pointer", "bg-white", {
          "border border-grey-light ringed rounded-md": !inline,
        })}
      >
        <input
          type="checkbox"
          aria-invalid={!!error}
          name={name}
          id={id}
          className={cls(
            "peer",
            "relative",
            "after:cursor-pointer",
            "w-6 h-6 mt-4 ml-4 mr-2",
            "before:absolute before:inline-block",
            "before:border before:rounded-sm",
            "before:w-6 before:h-6",
            "before:border-grey-light before:bg-grey-lightest",
            "before:transition-all before:duration-200",
            "after:transition-all after:duration-200",
            "icon-check icon-3 icon-transparent icon-inset-0",
            { "icon-3 icon-white": checked || false },
            { "before:border-green before:bg-green": checked || false }
          )}
          onChange={e => onValueChange(e.target.checked)}
          checked={checked}
        />
        <span
          className={cls(
            "pr-4 py-4 pl-2",
            "text-base text-black",
            "transition-all duration-200",
            { "!border-red": !!error },
            { "ringed rounded-md": inline || false }
          )}
          {...props}
        >
          {children && <span className={cls("text-black", { "!text-red": !!error })}>{children}</span>}
        </span>
      </label>
      {error && <ErrorMessage error={error} />}
    </div>
  );
};

export default CheckInputBlock;
